module.exports = __webpack_public_path__ + "media/images/premium/close-circle-991df298a4229de7fcc0cab44f1e3fd0.svg";